import axios from "axios";

const config = {
  getTeacherWebSite: getTeacherWebSite(),
  getTrainingData: getTrainingData()
};

/**
 * 获取教师端网址
 * @returns
 */
async function getTeacherWebSite() {
  let teacherWebSite = process.env.VUE_APP_TEACHER_WEBSITE;
  await axios.get("/config/config.json").then((res) => {
    if (process.env.NODE_ENV == "production") {
      teacherWebSite = res.data.teacherWebSite;
    } else {
      teacherWebSite = process.env.VUE_APP_TEACHER_WEBSITE;
    }
  });
  return teacherWebSite;
}

/**
 * 获取实训平台数据
 */
async function getTrainingData() {
  let trainingData = [];
  await axios.get("/config/config.json").then((res) => {
    trainingData = res.data.trainingData;
  });
  return trainingData;
}

export default config;
